import { Component, EventEmitter, Input, Output } from '@angular/core';
import { map } from 'rxjs';
import { IFilterData, IFilterModel } from '../../models/filter-model';
import { IFilter } from '../../interfaces/ifilter';
import { RevenuePaymentMethodService } from '../../services/revenue-payment-method.service';
import { FilterCustomModel } from '../../models/filter-custom-model';


@Component({
  selector: 'split-filter-payment-method',
  templateUrl: './split-filter-payment-method.component.html',
  styleUrls: ['./split-filter-payment-method.component.scss'],
  outputs: ['onFilterEvent'],
  inputs: ['field', 'label', 'key', 'groupId']
})
export class SplitFilterPaymentMethodComponent extends FilterCustomModel {

  constructor(private revenuePaymentMethodService: RevenuePaymentMethodService) {
    super();
  }

  ngOnInit(): void {
    this.onLoad();
  }

  onLoad() {
    let filter = this.filter.convertFilterInQuery();
    this.revenuePaymentMethodService.getAll(filter).pipe(
      map((paymentMethods: any[]) => paymentMethods.map(paymentMethods => ({ name: paymentMethods.name, id: paymentMethods.id as number } as IFilterData))),
    ).subscribe(
      (data: IFilterData[]) => {
        this.data = data;
      }
    )
  }

  onSearch($event: IFilter[]) {
    this.filter.setFilter($event[0].key as string, $event); 
    this.onLoad();
  }

}
